import React from 'react'

function Oops() {
  return (
    <div className='oops'>
      <span>404</span>
      <p>Page Not Found</p>
      <a href="https://wa.me/+2347035658853" target="_blank" rel='noreferrer'>Contact support</a>
    </div>
  )
}

export default Oops
